import { userLogIn } from './user';
import { LoginSection } from './login-section';
import breakpoints from '../ui/breakpoints';
import { OverlayHandler } from '../ui/overlays';
import { GoogleTagManager } from '../misc/ga-events';

const Overlay = new OverlayHandler();

function openLoginModal(e, elem, keyboard = false) {
	if (breakpoints.getBreakpoint() !== 'desktop' || elem.id === 'join-b2b') {
		e.preventDefault();

		const target = elem.dataset.target;
		if (target) {
			const targetElement = document.querySelector(target);
			if (targetElement) {
				// Custom classes for modal popup
				const classes = 'o-login--popup';

				// Create modal
				Overlay.createOverlay(targetElement, {
					trigger: elem,
					additionalClasses: classes.split(' '),
					returnToContainer: true,
					closeText: 'Sulje',
					keyboardFocus: keyboard,
					priorityPopup: true
				});
			}
		}
	}
}

function loginSuccess(data) {
	userLogIn(data.user);

	// Hide popup
	Overlay.closeActiveOverlay();
}

function initLogin(API) {
	// Callback function for ajax login
	API.loginComplete = (success, $form, data) => {
		if (success) {
			loginSuccess(data);
		}
	}
	// Callback function for ajax register
	API.registerComplete = (success, $form, data) => {
		if (success) {
			if (data.user) {
				// Update user info
				loginSuccess(data);

				// Send registration to GA
				GoogleTagManager.setRegistration();
				if (data.redirect) {

					// Add url parameter `br` for buyer role with value `c`
					document.location.href = '?br=c';
				}
			} else if (data.redirect) {
				// Redirect
				document.location.href = data.redirect;
			}
		}
	}
	// Callback function for ajax forgot password
	API.resetPasswordRequestOTP = (success, $form, data) => {
		if (success) {
			// Copy email from step 1 to step 2
			const email = $form.querySelector('input[name="email"]').value;
			document.getElementById('reset-password-step-2').querySelector('input[name="email"]').value = email;
			showPasswordResetStep(2);
		}
	}

	API.resetPasswordLoginWithOTP = (success, $form, data) => {
		if (success) {
			// Copy email from step 2 to step 3
			const email = $form.querySelector('input[name="email"]').value;
			document.getElementById('reset-password-step-3').querySelector('input[name="email"]').value = email;

			// Copy otp from step 2 to step 3
			const otp = $form.querySelector('input[name="otp"]').value;
			document.getElementById('reset-password-step-3').querySelector('input[name="otp"]').value = otp;

			showPasswordResetStep(3);
		}
	}

	API.resetPasswordWithOTP = (success, $form, data) => {
		if (success) {
			// All done! Hide form and show success message
			showPasswordResetStep(4);
		}
	}

	/*
	 * Login popup
	 */

	// Initialize login sections
	const loginSections = document.getElementsByClassName('js-login');
	// Look for specific id 'join-b2b' to open registration popup instead of login
	const b2bJoinElementFound = document.getElementById('join-b2b') !== null;
	for (let elem of loginSections) {
		if (elem.classList.contains('login-initialized')) {
			return;
		}
		elem.classList.add('login-initialized');
		if (b2bJoinElementFound) {
			elem.classList.add('b2b-join-initialized');
		}
		new LoginSection(elem);
	}

	// If currently in login page, do not initialize popup login
	if (window.isLoginPage) {
		return;
	}

	// Popup triggers
	const popupTriggers = document.getElementsByClassName('js-login-popup-trigger');
	for (const trigger of popupTriggers) {
		// With click
		trigger.addEventListener('click', (e) => {
			if (trigger.classList.contains('login-popup')) {
				e.preventDefault();
			}
			openLoginModal(e, trigger);
		});

		// With keyboard
		trigger.addEventListener('keydown', (e) => {
			switch (e.key) {
				case ' ':
				case 'Enter':
					openLoginModal(e, trigger, true);
					return;
			}
		});
	}
}

function sanitizePasswordResetStep(step) {
	const minStep = 1;
	const maxStep = document.querySelectorAll('.reset-password-step').length;

	if (!step) {
		const currentStep = parseInt(document.querySelector('.reset-password-step:not(.hidden)')?.dataset.step);
		if (!currentStep) {
			// Error. Maybe password reset element is not on the page.
			return false;
		}

		step = currentStep + 1;
	}

	if (step < minStep) step = 1;
	if (step > maxStep) step = maxStep;
	return parseInt(step);
}

function showPasswordResetStep(step) {
	step = sanitizePasswordResetStep(step);
	if (!step) {
		return;
	}

	const steps = document.querySelectorAll('.reset-password-step');
	for (const stepElem of steps) {
		if (parseInt(stepElem.dataset.step) === step) {
			stepElem.classList.remove('hidden');
			stepElem.querySelector('input:not([type="hidden"])').focus();
		} else {
			stepElem.classList.add('hidden');
		}
	}
}

export { initLogin, showPasswordResetStep };
